<template>
  <v-data-table
      v-if="userRole == 0 || userRole == 1 || userRole == 5 || userRole == 8"
      v-model="selected"
      :headers="headers"
      :items="evaluationsToDisplay()"
      :loading="loading"
      :options.sync="options"
      :search="options.search"
      :single-select=singleSelect
      class="elevation-1 ma-4"
      item-key="key"
      loading-text="Wczytuję listę... proszę czekać"
      show-select
      sort-by="date"
  >
    <template v-slot:top>
      <v-toolbar color="white" flat>
        <v-toolbar-title>Dziennik (nowy)</v-toolbar-title>
      </v-toolbar>
      <p class="pl-4">Aby zobaczyć listę studentów, proszę wybrać wartość z każdego z filtrów (aktualną sesję, kierunek, przedmiot oraz nabór)</p>

      <v-toolbar color="white" flat>
        <SelectSesions @semesterChanged="semesterChanged"/>
        <SelectCourse @courseChanged="courseChanged"/>
        <SelectSubjectsJoined @subjectChanged="subjectChanged"/>
        <SelectHalf @halfChanged="halfChanged" />
        <v-spacer></v-spacer>
        <v-text-field
            v-model="options.search"
            append-icon="search"
            hide-details
            label="Szukaj"
            single-line
        ></v-text-field>
        <v-spacer></v-spacer>
<!--        <v-btn :color=buttonForRemove dark rounded small class="mb-2 ml-4" @click="removeSelected()"><v-icon small>delete_outline</v-icon>Usuń zaznaczonych słuchaczy</v-btn>-->
        <v-dialog v-model="evaluationDialog" max-width="800px">
          <v-card>
            <v-card-title>
              <v-container class="text-center">
                <v-row>
                  <v-col sm="12">
                    <span class="headline">Oceny</span>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">
                      Nazwa przedmiotu
                    </th>
                    <th class="text-left">
                      Ocena
                    </th>
                    <th class="text-left">
                      Wykładowca
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="subject in getEvaluationsByUserIdAndEvaluation(getChosenEvaluation)"
                      :key="subject"
                  >
                    <td>{{ subject.subject_name }}</td>
                    <td>
                      {{ subject.grade }}
                    </td>
                    <td>
                      {{ loggedInUser.id == subject.professor_id ? 'JA - ' : '' }} {{ subject.professor_name }}
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-if="userRole == 1" v-slot:item.changes="{ item }">
      <!-- history -->
      <v-tooltip v-if="history(item.uid)" top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
              color="red"
              v-bind="attrs"
              v-on="on">
            warning
          </v-icon>
        </template>
        <span>W ciągu ostatniego miesiąca wprowadzono zmiany w kwestionariuszu osobowym</span>
      </v-tooltip>
    </template>
    <template v-slot:item.date="{ item }">
      {{ new Date(item.date) | moment }}
    </template>
    <template v-slot:item.grade="{ item }">
      <ProfessorGrade
          :id="item.esid"
          :changed-grade="changedGrade.find(x => x == item.subjectId)"
          :eid="item.eid"
          :grade="item.grade"
          :professorId="item.professor_id"
          :subjectId="item.subjectId"
          :uid="item.uid"
      />
    </template>
    <template v-slot:item.status="{ item }">
      <v-icon>{{ (item.status)?'check_circle_outline':'warning' }}</v-icon>
    </template>
    <template v-slot:item.action="{ item }">
      <a @click="showGrades(item.id, item.uid);">
        <v-icon
            class="mr-8"
            small
        >
        </v-icon>Podgląd
      </a>
      &nbsp;
      <a @click="setChosenEvaluation(item.id); $router.push('/professor-evaluations-joined/' + item.uid + '/true')">
        <v-icon
            class="mr-0"
            small
        >
        </v-icon>Edycja
      </a>
    </template>
    <template v-slot:no-data>
      Brak słuchaczy
    </template>
    <template v-slot:footer>
      <v-divider></v-divider>
      <div class="mt-4 mb-4 mr-4">
        <v-row>
          <v-col class="d-flex" md="3">
              <a v-if="subjectSelected && getLastProtocolByType(1)" class="ml-4" @click="downloadProtocol(JSON.parse(getLastProtocolByType(1).pdfData), getLastProtocolByType(1).title)">
                <v-icon class="gray--text">picture_as_pdf</v-icon> protokół_sesja_{{ getLastProtocolByType(1).type | translateProtocolType }}.pdf
              </a>
          </v-col>
          <v-col class="d-flex justify-start" md="4">
              <a v-if="subjectSelected && getLastProtocolByType(2)" class="ml-10" @click="downloadProtocol(JSON.parse(getLastProtocolByType(2).pdfData), getLastProtocolByType(2).title)">
                <v-icon class="gray--text">picture_as_pdf</v-icon> protokół_sesja_{{ getLastProtocolByType(2).type | translateProtocolType }}.pdf
              </a>
          </v-col>
          <v-col class="d-flex justify-end" md="5">
            <v-toolbar color="white" flat>
  <!--            <v-btn :color=buttonForRemove class="mr-4" @click="newMessage()" dark rounded small>Napisz wiadomość</v-btn>-->
              <v-select v-model="protocolTypeSelected"
                        :items="getProtocolTypesForGeneration()"
                        :label=protocolTypeSelected
                        class="text-right ml-2"
                        item-text="value"
                        item-value="key"
                        menu-props="auto"
                        placeholder="Wybierz rodzaj protokołu"
                        single-line
              >
              </v-select>
              <v-spacer></v-spacer>
              <v-tooltip v-if="(courseSingleSelected == null || subjectSelected == null || subjectSelected.length == 0 || semesterSelected == null || semesterSelected.length == 0 || evaluationsToDisplay().length == 0 || protocolTypeSelected == null)" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mr-4" color="grey" dark  rounded small v-bind="attrs" v-on="on">Generuj protokół</v-btn>
                </template>
                <span>Aby wygenerować protokół, najpierw użyj filtrów aby wybierać semestr, kierunek i konkretny przedmiot oraz typ protokołu. Protokoły z sesji można generować od 26.02 do 12.03 i 28.06 do 11.07 (podstawowa) oraz od 12.03 do 04.04 i od 11.07 do 11.08 (poprawkowa)</span>
              </v-tooltip>
              <v-btn v-else class="mr-4" color="primary" dark rounded small @click="generateProtocol()">Generuj protokół</v-btn>
            </v-toolbar>
          </v-col>
        </v-row>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SelectSesions from "./SelectSesions";
import SelectCourse from "./SelectCourse";
import SelectSubjectsJoined from "./SelectSubjectsJoined";
import SelectHalf from "./SelectHalf";
import moment from "moment";
import ProfessorGrade from "../components/ProfessorGrade";
import {ComponentWithPagingEnum} from '../enums';

export default {
  name: "Evaluations",
  components: {ProfessorGrade, SelectSesions, SelectCourse, SelectSubjectsJoined, SelectHalf },
  filters: {
    moment: function (date) {
      return moment(date).format('MMMM YYYY');
    }
  },
  computed: {
    ...mapGetters({
      // evaluations
      evaluations: 'evaluations/getEvaluations',
      getEvaluationsBySubjectId: 'evaluations/getEvaluationsBySubjectId',
      dialogFromStore: 'evaluations/dialogNew',
      protocolTypeSelectedFromStore: 'evaluations/protocolTypeSelected',
      getChosenEvaluation: 'evaluations/getChosenEvaluation',
      getEvaluationsByUserIdAndEvaluation: 'evaluations/getEvaluationsByUserIdAndEvaluation',

      // courses
      courses: 'courses/getCourses',
      coursesWithoutAllOption: 'courses/getCoursesWithoutAllOption',
      courseSingleSelected: 'courses/getCourseSingleSelected',

      // places
      places: 'places/getPlaces',
      coordinators: 'places/getCoordinators',

      // users
      userRole: 'users/userRole',
      loggedInUser: 'users/getLoggedInUser',
      getNameById: 'users/getNameById',
      semesterSelected: 'semesterSelected',

      getLastProtocolByType: 'protocols/getLastProtocolByType',
      subjectSelected: 'subjects/getSubjectSelected',
      halfSelected: 'halfSelected',

      history: 'history/getHistoryRecent',

      getPage: 'paging/getPage'
    }),
    buttonForRemove () {
      if (this.selected.length > 0) {
        return 'primary'
      } else {
        return 'secondary'
      }
    },
    formTitle () {
      return this.editedIndex === -1 ? 'Dodaj nowego słuchacza' : 'Edytuj słuchacza'
    },
    dialog: {
      get(){
        return this.dialogFromStore
      },
      set(value){
        return this.setDialogNew(value)
      }
    },
    semesterChoices: {
      get() {
        return [
          {
            'key': moment('2022-03-01').format('YYYY-MM-DD'),
            'value': moment('2022-03-01').locale('pl').format('MMMM YYYY')
          },
          {
            'key': moment('2021-10-01').format('YYYY-MM-DD'),
            'value': moment('2021-10-01').locale('pl').format('MMMM YYYY')
          },
          {
            'key': moment('2021-03-01').format('YYYY-MM-DD'),
            'value': moment('2021-03-01').locale('pl').format('MMMM YYYY')
          },
          {
            'key': moment('2020-10-01').format('YYYY-MM-DD'),
            'value': moment('2020-10-01').locale('pl').format('MMMM YYYY')
          },

        ]
      },
      set(value){
        return this.setMonthSelected(value)
      }
    },
    protocolTypeSelected: {
      get() {
        return this.protocolTypeSelectedFromStore
      },
      set(value){
        return this.setProtocolTypeSelected(value)
      }
    },

  },
  mounted () {
    this.setSelectedComponent(ComponentWithPagingEnum.evaluations);
    this.options = this.getPage;
  },
  data: () => ({
    loading: false,
    ansImage: "",
    selected: [],
    menuDate: false,
    dialogNewSuccess: false,
    dialogNewSuccessUserExists: false,
    dialogNewError: false,
    dialogRemoveSuccess: false,
    dialogMessage: false,
    headers: [
      { text: 'Nazwisko i imię', value: 'username' },
      { text: '', value: 'changes' },
      { text: 'Kierunek', value: 'courseName' },
      { text: 'Przedmiot', value: 'subjectName' },
      { text: 'Nabór', value: 'student_course_date' },
      { text: 'Ocena', value: 'grade' },
      { text: '', value: 'action', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      cid: '',
      cid_2: '',
      pid: '',
      price: '',
      comment: '',
      coordinator: '',
      date: ''
    },
    defaultItem: {
      cid: '',
      cid_2: '',
      pid: '',
      price: '',
      comment: '',
      coordinator: '',
      date: ''
    },
    singleSelect: false,
    validate: false,
    report: false,
    evaluationDialog: false,
    changedGrade: [],
    options: {},
  }),
  watch: {
    dialogNewSuccess (val) {
      val || setTimeout(() => {
        this.clearEditItem()
      }, 300)
    },
    dialogNewSuccessUserExists (val) {
      val || setTimeout(() => {
        this.clearEditItem()
      }, 300)
    },
    dialog (val) {
      val || setTimeout(() => {
        this.clearEditItem()
      }, 300)
    },
    options: {
      handler () {
        this.handlePage()
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      setDialogNew: 'evaluations/setDialogNew',
      deleteEvaluations: 'evaluations/deleteEvaluations',
      setChosenEvaluation: 'evaluations/setChosenEvaluation',
      resetChosenEvaluation: 'evaluations/resetChosenEvaluation',
      studentEvaluations: 'evaluations/getEvaluationsByUserId',
      clearEvaluations: 'evaluations/clearEvaluations',
      clearSubjects: 'subjects/clearSubjects',
      setPage: 'paging/setPage',
      setSelectedComponent: 'paging/setSelectedComponent',
      clearPage1: 'paging/clearPage',
      saveProtocol: 'protocols/saveProtocol',
      clearProtocols: 'protocols/clearProtocols',
      setProtocolTypeSelected: 'evaluations/setProtocolTypeSelected',
      setHalfSelected: 'setHalfSelected',
    }),
    getProtocolTypesForGeneration() {
      let protocolTypes = [];
      let today = moment();

      let firstFrom1 = moment(new Date().getFullYear() + '-02-26','YYYY-MM-DD');
      let firstTo1 = moment(new Date().getFullYear() + '-03-12','YYYY-MM-DD'); // till end of 11
      let firstFrom2 = moment(new Date().getFullYear() + '-06-28','YYYY-MM-DD');
      let firstTo2 = moment(new Date().getFullYear() + '-07-11','YYYY-MM-DD');

      let secondFrom1 = moment(new Date().getFullYear() + '-03-12','YYYY-MM-DD'); // from begining of 12
      let secondTo1 = moment(new Date().getFullYear() + '-04-04','YYYY-MM-DD');
      let secondFrom2 = moment(new Date().getFullYear() + '-07-11','YYYY-MM-DD');
      let secondTo2 = moment(new Date().getFullYear() + '-08-11','YYYY-MM-DD');

      let monthsFromStart = moment().diff(moment(this.semesterSelected), 'months', true);

      if (this.userRole == 1 || ((this.userRole == 0 || this.userRole == 5 || this.userRole == 8) && (monthsFromStart > 3 && monthsFromStart < 7) && today.isBetween(firstFrom1, firstTo1) || today.isBetween(firstFrom2, firstTo2))) {
        protocolTypes.push({ value: 'Generuj z sesji 1', key: 1});
      }

      if (this.userRole == 1 || ((this.userRole == 0 || this.userRole == 5 || this.userRole == 8) && (monthsFromStart > 3 && monthsFromStart < 7) && today.isBetween(secondFrom1, secondTo1) || today.isBetween(secondFrom2, secondTo2))) {
        protocolTypes.push({value: 'Generuj z sesji poprawkowej', key: 2});
      }
      return protocolTypes;
    },
    clearPage () {
      this.clearPage1();
      this.options.page = 1;
    },
    handlePage() {
      let { sortBy, sortDesc, page, itemsPerPage, search } = this.options;
      this.setPage({ sortBy: sortBy, sortDesc: sortDesc, page: page, itemsPerPage: itemsPerPage, search: search })

    },
    getProtocols(subjectId) {
      if (!this.courseSingleSelected || !this.semesterSelected || !subjectId) {
        this.clearProtocols();
        this.getLastProtocolByType(1);
        this.getLastProtocolByType(2);
      } else {
        this.loading = true;
        this.$store.dispatch(
            'protocols/getProtocols',
            {
              'date': this.semesterSelected ? moment(this.semesterSelected).startOf('month').format('YYYY-MM-DD') : '',
              'cid': this.courseSingleSelected,
              'sid': subjectId
            }
        ).then(() => {
          this.loading = false;
        });
      }
    },
    getBase64ImageFromURL(url) {
      let file = new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          var dataURL = canvas.toDataURL("image/png");

          resolve(dataURL);
        };

        img.onerror = error => {
          reject(error);
        };

        img.src = url;
      }).catch((error) => { console.log(error) });
      return file;
    },
    evaluationsToDisplay() {
      if(this.subjectSelected !== null) {
        return this.getEvaluationsBySubjectId(this.subjectSelected)
      } else {
        return this.evaluations;
      }
    },
    showGrades(itemId, userId) {
      this.setChosenEvaluation(itemId)
      this.studentEvaluations(userId);
      this.evaluationDialog = true;
    },
    editItem (item) {
      this.setChosenEvaluation(item.id)
      this.editedIndex = this.evaluations.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true
    },
    removeSelected () {
      if (this.selected.length == 0) {
        return false
      }
      if(confirm('Czy na pewno chcesz usunąć tego słuchacza?')){
        this.deleteEvaluations(this.selected).then(response => {
          this.$log.info('Deleted user', response);
          this.dialogRemoveSuccess = true
        }).catch(error => {
          this.$log.error('Deleting user error', error)
        })
      }
    },
    newMessage() {
      if (this.selected.length == 0) {
        return false
      }
      this.dialogMessage = true;
    },
    async generateProtocol() {
      var table = [];
      table.push(["l.p.", "Nazwisko", "Imię", "Ocena ostateczna", "Podpis egzaminatora"]);

      function getEvaluationItems() {
        return function (obj, index) {
          const i = obj.username.lastIndexOf(' ');
          return [index + 1, obj.username.slice(0, i), obj.username.slice(i + 1), ((obj.grade == undefined) ? '' : obj.grade), ''];
        }
      }

      let itemsInProtocol = this.evaluationsToDisplay();
      if (this.selected && this.selected.length > 0) {
        itemsInProtocol = this.selected;
      }

      var tableBody = table.concat(itemsInProtocol.sort((a, b) => {
        let fa = a.username.toLowerCase(),
            fb = b.username.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      }).map(getEvaluationItems()
      ));

      let c = [];
      c.push({
        image: await this.getBase64ImageFromURL("api/evaluations/logoForReport"),
        style: 'header'
      });
      c.push({
        stack: [
          '20-816 Lublin, ul. Choiny 2, tel. 81 740 72 40, www.wssp.edu.pl',
        ],
        style: ['center', 'singleLine']
      });
      c.push({
        canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ],
        style: 'header'
      });
      c.push({
        columns: [{
          text: 'Akademia Nauk Stosowanych Wincentego Pola w Lublinie\n',
          style: ['dataLeft', 'bold']
        }, {text: 'PROTOKÓŁ', style: ['bold', 'center']}]
      })
      c.push({
        columns: [{text: '', style: 'dataLeft'}, {
          text: 'Egzamin/Zaliczenie (niepotrzebne skreślić)',
          style: 'data'
        }]
      })
      c.push({
        columns: [
          {
            text: 'Studia podyplomowe',
            style: 'dataLeft'
          },
          {
            text: ['Z przedmiotu: ', { text: this.evaluationsToDisplay()[0].subjectName, style: 'bold'}], style: 'data'
          }
        ]
      });
      c.push({
        columns: [
          {
            text: ['Zakres studiów: ', { text: this.evaluationsToDisplay()[0].courseName, style: 'bold'}],
            style: 'dataLeft'
          },
          {
            text: 'z dnia: ................................................', style: 'data'
          }
        ]
      });
      c.push({
        columns: [
          {
            text: 'Semestr: ' + this.halfSelected,
            style: 'dataLeft'
          },
          {
            text: ['Egzaminator: ', { text: (this.userRole == 0 || this.userRole == 5) ? (JSON.parse(this.loggedInUser.registration_form).personal.degree ? JSON.parse(this.loggedInUser.registration_form).personal.degree + ' ' + this.loggedInUser.name : this.loggedInUser.name) : this.getNameById(this.evaluationsToDisplay()[0].professor_id), style: 'bold'}]
          }
          ]
      })
      c.push({
        style: 'tableExample',
        table: {
          body: tableBody
        }
      });
      c.push({text: '..............................', style: 'signature'})
      c.push({text: 'podpis osoby upoważnionej', style: 'signatureLabel'})
      var docDefinition = {
        content: c,
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
            alignment: "center"
          },
          center: {
            alignment: "center"
          },
          dataLeft: {
            fontSize: 12,
            alignment: "justify",
            margin: [0, 0, 20, 20],
          },
          bold: {
            bold: true,
          },
          data: {
            fontSize: 12,
            bold: false,
            alignment: "justify",
            margin: [0, 0, 0, 20],
          },
          footer: {
            alignment: "right",
            margin: [0, 20, 0, 20]
          },
          label: {
            fontSize: 8,
            bold: false,
            alignment: "left"
          },
          singleLine: {
            margin: [0, 0, 0, 20],
          },
          singleLineBold: {
            bold: true,
            margin: [0, 0, 0, 20],
          },
          signature: {
            alignment: "right",
            margin: [20, 30, 30, 0]
          },
          signatureLabel: {
            alignment: "right",
            margin: [0, 0, 30, 0],
            fontSize: 8,
            bold: false,
          }
        }
      };


      let title = 'Protokół dla naboru ' + this.evaluationsToDisplay()[0].subjectName + ' ' + moment(this.semesterSelected).startOf('month').format('YYYY-MM-DD') + '.pdf';

      this.saveProtocol({
        pdf_data: JSON.stringify(docDefinition),
        date: this.semesterSelected ? moment(this.semesterSelected).startOf('month').format('YYYY-MM-DD') : '',
        cid: this.courseSingleSelected,
        sid: this.subjectSelected,
        uid_professor: (this.userRole == 0 || this.userRole == 5) ? this.loggedInUser.id : this.evaluationsToDisplay()[0].professor_id,
        type: this.protocolTypeSelectedFromStore,
        title: title
      }).then(response => {
        if (response == 200) {
          this.$log.info('Saved protocol ', response);

          this.downloadProtocol(docDefinition, title);

          // refresh list
          this.getProtocols(this.subjectSelected);
        }
      }).catch(error => {
        this.$log.error('Saving protocol error', error)
      })
    },

    downloadProtocol(pdfData, title) {
      var pdfMake = require('pdfmake/build/pdfmake.js');
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js');
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      pdfMake.createPdf(pdfData).download(title);
    },

    closeDialogMessage(val) {
      this.dialogMessage = val;
    },

    getEvaluations(half = null, subjectId = null) {
      let subjectNow = subjectId;
      if (this.subjectSelected !== null) {
        subjectNow = this.subjectSelected;
      }
      console.log('Semester: ' + this.semesterSelected, ', Course: ' + this.courseSingleSelected, ', Subject: ' + subjectNow, ', Half: ' + this.halfSelected, ', Role: ' + this.userRole);
      if(
          (this.courseSingleSelected !== null) &&
          this.semesterSelected &&
          (subjectNow !== null) &&
          (this.userRole == 0 || this.userRole == 5 || this.userRole == 1 || this.userRole == 8)
      ) {
        this.loading = true;
        this.$store.dispatch(
            'evaluations/getEvaluationsJoined',
            {
              'date': this.semesterSelected ? moment(this.semesterSelected).startOf('month').format('YYYY-MM-DD') : '',
              'cid': this.courseSingleSelected,
              'sid': subjectNow,
              'half': half
            }
        ).then(() => {
          this.loading = false;
          this.getProtocols(subjectNow);
        });
      } else {
        this.clearEvaluations();
      }
      this.clearPage();
    },
    semesterChanged(date) {
      // this.getEvaluations();
      this.clearEvaluations();
      this.setHalfSelected(null);

    },
    courseChanged(courseId) {
      this.clearPage();
      this.clearSubjects();
      this.clearEvaluations();
      this.setHalfSelected(null);
      // this.getEvaluations();

    },
    subjectChanged(subjectId) {
      this.clearPage();
      this.clearEvaluations();
      this.setHalfSelected(null);
      this.getEvaluations(null, subjectId);
      // this.getProtocols(subjectId);
    },
    halfChanged(half) {
      if (half == null) {
        this.clearEvaluations();
      }
      this.clearPage();
      this.getEvaluations(half);
      // this.getProtocols(subjectId);
    },
    selectedItems() {
      let mapped = Object.assign({}, this.selected.map(x => x.email ));
      return { email: mapped, subject: '' };
    }
  },
  created() {
    this.clearEvaluations();
    this.resetChosenEvaluation();
    this.setHalfSelected(null);

    this.$store.dispatch('courses/getCourses');

    if(this.semesterSelected && (this.userRole !== 0 && this.userRole !== 5)) {
      this.$store.dispatch('history/getHistoryRecent');
    }
  }
}
</script>

<style scoped>
.toPrint {
  display: none;
}
.evaluationUserDetail {
  white-space: nowrap;
}
</style>
